import type { CSSProperties } from "react";

const iconWrap: CSSProperties = {
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  lineHeight: 0,
  flexShrink: 0,
  color: "rgba(42, 41, 41, 0.45)",
};

type IconProps = {
  size?: number;
  className?: string;
  style?: CSSProperties;
};

export function AuthIconUser({ size = 18, className, style }: IconProps) {
  return (
    <span
      className={className}
      style={{ ...iconWrap, ...style }}
      aria-hidden
    >
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill="currentColor"
          d="M12 6a3 3 0 100 6 3 3 0 000-6zm0 8c-3.9 0-7 2-7 5h14c0-3-3.1-5-7-5z"
        />
      </svg>
    </span>
  );
}

export function AuthIconLock({ size = 18, className, style }: IconProps) {
  return (
    <span
      className={className}
      style={{ ...iconWrap, ...style }}
      aria-hidden
    >
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M17 11V8a5 5 0 10-10 0v3H5a2 2 0 00-2 2v7a2 2 0 002 2h14a2 2 0 002-2v-7a2 2 0 00-2-2h-2zm-8 0V8a3 3 0 016 0v3H9z"
          fill="currentColor"
        />
      </svg>
    </span>
  );
}

/** Forward in LTR; add class `ac-auth-arrow--rtl` on wrapper for Arabic */
export function AuthIconArrowForward({
  size = 16,
  className,
  style,
}: IconProps) {
  return (
    <span
      className={className}
      style={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        lineHeight: 0,
        flexShrink: 0,
        ...style,
      }}
      aria-hidden
    >
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M4 12h11M13 7l5 5-5 5"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  );
}
